import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { IWhyCardProps } from "../../types/componentsConstructors";
import {
  CardWrapper,
  Container,
  Divider,
  IconWrapper,
  TextBlock,
  Title,
  Description,
} from "./WhyCardStyles";

const WhyCard = ({ icon, title, description }: IWhyCardProps) => {
  const cardRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: cardRef,
    offset: ["start end", "end start"],
  });

  const translateY = useTransform(scrollYProgress, [0, 1], [0, -30]);

  return (
    <motion.div
      ref={cardRef}
      style={{ perspective: 1000, translateY }}
      whileHover={{ y: -8, rotateX: 4, rotateY: -4 }}
      transition={{ type: "spring", stiffness: 150, damping: 12 }}
    >
      <CardWrapper>
        <Container>
          <IconWrapper>
            <img src={icon} alt={title} />
          </IconWrapper>
          <TextBlock>
            <Title>{title}</Title>
            <Description>{description}</Description>
          </TextBlock>
        </Container>
        <Divider />
      </CardWrapper>
    </motion.div>
  );
};

export default WhyCard;
